import React from 'react';

const fillColor = {
  default: '#FFAA00',
  errorDark: '#D34317',
  errorMain: '#E26B33'
}

function EmergencyIcon({ color = 'default', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="currentColor"
      {...props}
    >
      <mask
        id="mask0_3388_9957"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3388_9957)">
        <path
          d="M16 29.3667C15.6444 29.3667 15.3055 29.3 14.9833 29.1667C14.6611 29.0333 14.3666 28.8444 14.1 28.6L3.39997 17.9C3.15552 17.6333 2.96663 17.3389 2.8333 17.0167C2.69997 16.6944 2.6333 16.3556 2.6333 16C2.6333 15.6444 2.69997 15.3 2.8333 14.9667C2.96663 14.6333 3.15552 14.3444 3.39997 14.1L14.1 3.4C14.3666 3.13333 14.6611 2.93889 14.9833 2.81666C15.3055 2.69444 15.6444 2.63333 16 2.63333C16.3555 2.63333 16.7 2.69444 17.0333 2.81666C17.3666 2.93889 17.6555 3.13333 17.9 3.4L28.6 14.1C28.8666 14.3444 29.0611 14.6333 29.1833 14.9667C29.3055 15.3 29.3666 15.6444 29.3666 16C29.3666 16.3556 29.3055 16.6944 29.1833 17.0167C29.0611 17.3389 28.8666 17.6333 28.6 17.9L17.9 28.6C17.6555 28.8444 17.3666 29.0333 17.0333 29.1667C16.7 29.3 16.3555 29.3667 16 29.3667ZM14.6666 17.3333H17.3333V9.33333H14.6666V17.3333ZM16 21.3333C16.3777 21.3333 16.6944 21.2056 16.95 20.95C17.2055 20.6944 17.3333 20.3778 17.3333 20C17.3333 19.6222 17.2055 19.3056 16.95 19.05C16.6944 18.7944 16.3777 18.6667 16 18.6667C15.6222 18.6667 15.3055 18.7944 15.05 19.05C14.7944 19.3056 14.6666 19.6222 14.6666 20C14.6666 20.3778 14.7944 20.6944 15.05 20.95C15.3055 21.2056 15.6222 21.3333 16 21.3333Z"
          fill={fillColor[color]}
        />
      </g>
    </svg>
  );
}

export default EmergencyIcon;